export default __webpack_public_path__ + "aa665de0b27ea361167006727d99a8aa.svg";